import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import FileTag from "./FileTag";
import { v4 as uuidv4 } from "uuid";

const FileInput = ({ item }) => {
  const {
    label,
    name,
    type,
    defaultValue,
    multiple,
    multipleData,
    fullCol,
    fullHeight,
    required,
    handleSingleDelete,
  } = item;

  // const [quantityCount, setCount] = useState(multipleData);
  // const handleAddElement = () => {
  //   setCount((current) => [
  //     ...current,
  //     {
  //       label: label,
  //       type: "file",
  //       name: "",
  //       defaultValue: "",
  //     },
  //   ]);
  // };
  // NEW CODE
  const [allData, setAllData] = useState([
    <div key={uuidv4()}>
      <input
        type="text"
        name="url"
        defaultValue={item.url}
        className="border mb-2"
        // onChange={(event) => handleInputChange(idx, event)}
      />
      <span
        onClick={() => handleRemoveData(item)}
        className="border p-2 py-0.5"
      >
        Remove
      </span>
    </div>,
  ]);

  const handleAddData = () => {
    const values = [...allData];
    let identifier = uuidv4();
    values.push(
      <div key={identifier} id={identifier}>
        <input
          type="text"
          name="url"
          defaultValue={""}
          className="border mb-2"
          // onChange={(event) => handleInputChange(idx, event)}
        />
        <span
          onClick={() => handleRemoveData(identifier)}
          className="border p-2 py-0.5"
        >
          Remove
        </span>
      </div>
    );
    setAllData(values);
  };

  const handleRemoveData = (id) => {
    const values = [...allData];

    const newData = values.filter((data) => data.key !== id);
    setAllData(newData);
  };

  const handleInputChange = (index, event) => {
    const values = [...allData];
    const updatedValue = event.target.name;
    values[index][updatedValue] = event.target.value;

    setAllData(values);
  };

  return (
    <div
      className={
        fullCol
          ? "col-span-4 flex items-center sm:items-start justify-center sm:justify-start w-full py-2 ssm:py-8"
          : "col-span-4 sm:col-span-2 py-2 ssm:py-8 w-full"
      }
    >
      <div
        className={fullCol ? `${fullHeight ? "w-fit" : "w-full"}` : "w-full"}
      >
        {multiple && allData?.length > 0 && allData?.map((item) => item)}

        {/* <FileTag
              label={label}
              name={name}
              defaultValue={item.url}
              type={type}
              multiple={multiple}
              required={required}
              fullHeight={fullHeight}
            /> */}

        {!multiple && (
          <FileTag
            label={label}
            length={0}
            name={name}
            defaultValue={defaultValue}
            type={type}
            multiple={multiple}
            required={required}
            fullHeight={fullHeight}
          />
        )}
        {/* {multipleData ? (
          quantityCount.map((item, index) => (
            <FileTag
              key={index}
              label={label}
              length={index + 1}
              name={name}
              defaultValue={item.defaultValue}
              type={type}
              multiple={multiple}
              handleSingleDelete={handleSingleDelete}
              fullHeight={fullHeight}
            />
          ))
        ) : (
          // single input
          <FileTag
            label={label}
            length={0}
            name={name}
            defaultValue={defaultValue}
            type={type}
            multiple={multiple}
            required={required}
            fullHeight={fullHeight}
          />
        )} */}
      </div>

      {multiple && (
        <div className="flex justify-center items-end">
          <button
            onClick={handleAddData}
            type="button"
            className="btn btn-circle border border-gray-400 rounded-full p-4 hover:bg-gray-50"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default FileInput;
